<template>
  <div class="distribution">
    <div class="content" v-if="!1">
      <h1>登录</h1>
      <p>一键登录 享便捷服务</p>
      <div class="form">
        <div class="line flex">
          <input
            type="number"
            v-model="mobile"
            placeholder="请输入手机号"
            maxlength="11"
          />
        </div>
        <div class="line flex">
          <input
            type="number"
            v-model="checkCode"
            placeholder="请输入验证码"
            maxlength="6"
          />
          <span
            id="code"
            :class="mobile && mobile.length == 11 ? '' : 'gray'"
            @click="sendCode"
            >{{ timerText }}</span
          >
        </div>
      </div>
      <div class="btn" @click="loginByMobile">登录</div>
    </div>
  </div>
</template>

<script>
var common = require("../assets/script/common");
import axios from "axios";
import qs from "qs";
export default {
  name: "distribution",
  data() {
    return {
      mobile: "",
      checkCode: "",
      second: 0,
      timerText: "发送验证码",
    };
  },
  mounted() {
    var distributorId = this.$route.query.distributorId || "";
    if (distributorId) {
      localStorage.setItem("distributorId", distributorId);
      location.href = "https://m.angemo.com?distributorId=" + distributorId;
    } else {
      location.href = "https://m.angemo.com";
    }
  },
  methods: {
    sendCode() {
      var self = this;
      if (self.mobile == "" || self.second > 0) {
        return false;
      }
      var mobile = self.mobile;
      if (mobile === "") {
        self.$alert({
          text: "请输入手机号",
        });
        return false;
      }
      if (!common.default.isMobile(mobile)) {
        self.$alert({
          text: "请输入正确的手机号",
        });

        return false;
      }
      common.default
        .request({
          url: "/basis/sendCheckCode",
          data: {
            mobile: mobile,
            checkSign: encodeURIComponent(
              self.aesEncrypt(
                common.default.formatDate(new Date(), "yyyyMMddHHmmss")
              )
            ),
          },
        })
        .then((res) => {
          self.second = 30;
          self.countdown();
        });
    },
    countdown() {
      var self = this;
      var isOver = false;
      var span = document.getElementById("code");

      self.timerText = self.second + "S";
      span.innerHTML = self.timerText;
      if (self.second <= 0) {
        self.timerText = "发送验证码";
        span.innerHTML = self.timerText;
      }
      isOver = self.second <= 0;
      self.second = self.second - 1;

      if (isOver == false) {
        setTimeout(function () {
          self.countdown();
        }, 1000);
      }
    },
    aesEncrypt(word) {
      var mode = new Crypto.mode.CBC(Crypto.pad.pkcs7);
      var eb = Crypto.charenc.UTF8.stringToBytes(word);
      var kb = Crypto.charenc.UTF8.stringToBytes("mianmian@yue.com"); //KEY
      var vb = Crypto.charenc.UTF8.stringToBytes("mianmianmianmian"); //IV
      var ub = Crypto.AES.encrypt(eb, kb, {
        iv: vb,
        mode: mode,
        asBpytes: true,
      });
      return ub;
    },
    loginByMobile() {
      var self = this;
      var mobile = self.mobile || "";
      var checkCode = self.checkCode || "";
      var distributorId = localStorage.getItem("distributorId") || 0;
      if (mobile === "") {
        self.$alert({
          text: "请输入手机号",
        });

        return false;
      }
      if (!common.default.isMobile(mobile)) {
        self.$alert({
          text: "请输入正确的手机号",
        });

        return false;
      }
      if (checkCode === "") {
        self.$alert({
          text: "请输入验证码",
        });
        return false;
      }

      let headers = common.default.getRequestHeader();
      headers["X-Access-Platform"] = 5;
      axios({
        method: "POST",
        url: "/member/login",
        baseURL: common.default.apiUrl(),
        data: qs.stringify({
          mobile: mobile,
          checkCode: checkCode,
          distributorId: distributorId,
        }),
        headers: headers,
      })
        .then((res) => {
          if (res && res.status === 200) {
            var data = res.data;
            if (data && data.response && data.response.code === 0) {
              self.$router.push({
                path: "/distributionLoadApp",
              });
            } else {
              common.default.defaultSuccessHandle(data);
            }
          }
        })
        .catch((xhr) => {
          common.default.defaultErrorHandle(xhr);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("../assets/style/rem.css");
.distribution {
  overflow: hidden;
  position: relative;
  color: #fff;
  background: #e863fe;
  height: 100vh;

  .content {
    width: 100%;
    min-height: 13.34rem;
    background: url("../assets/image/distribution/back.png") no-repeat;
    background-size: 100% auto;
  }

  h1 {
    font-size: 0.34rem;
    padding-top: 7rem;
    text-align: center;
    font-weight: normal;
  }
  p {
    font-size: 0.28rem;
    padding: 0.1rem 0 0.3rem;
    text-align: center;
  }

  .line {
    width: 6.1rem;
    height: 1rem;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 0.5rem;
    margin: 0 auto 0.4rem;
    padding-left: 0.76rem;
    box-sizing: border-box;
    position: relative;

    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0.4rem;
      top: 50%;
      transform: translateY(-50%);
    }

    &:nth-child(1) {
      &::before {
        width: 0.22rem;
        height: 0.32rem;
        background: url("../assets/image/distribution/mobile.png") no-repeat;
        background-size: 100% auto;
      }
    }
    &:nth-child(2) {
      &::before {
        width: 0.24rem;
        height: 0.28rem;
        background: url("../assets/image/distribution/code.png") no-repeat;
        background-size: 100% auto;
      }
      padding-right: 2rem;
    }

    input {
      color: #fff;
      font-size: 0.3rem;
      height: 1rem;
      width: 4rem;
      outline: none;

      &::placeholder {
        color: #fff;
      }
    }

    span {
      width: 1.6rem;
      height: 0.68rem;
      background: rgba(159, 80, 243, 1);
      color: #fff;
      border-radius: 0.4rem;
      display: block;
      font-size: 0.26rem;
      text-align: center;
      line-height: 0.68rem;
      white-space: nowrap;
      padding: 0 0.1rem;
      position: absolute;
      right: 0.2rem;
      top: 50%;
      transform: translateY(-50%);
    }

    .gray {
      color: #cccccc;
      background: #c197f7;
    }
  }

  .btn {
    width: 6.1rem;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.3rem;
    text-align: center;
    background: linear-gradient(
      90deg,
      rgba(244, 15, 254, 1) 0%,
      rgba(13, 205, 224, 1) 100%
    );
    border-radius: 0.5rem;
    color: #fff;
    margin: 0.3rem auto;
  }
}
</style>